module.exports = __webpack_public_path__ + "static/media/select-vice-captain.384e4ee9.svg";